import { BaseRequest } from './BaseRequest';

export class EditAppsRequest extends BaseRequest {
    OverrideCallbackUri: string;
}